<template>
	<svg width="224" height="73" viewBox="0 0 224 73" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L0.00532458 26.0714H6.41505L6.40973 6.41868H20.8372V0H0Z" fill="#4DAAE8" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.7209 46.9286V11.7322H35.1628V17.4654H18.4338V26.8161H34.699V32.4983H18.4338V46.9286H11.7209Z"
			fill="#666666"
		/>
		<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="36" y="9" width="188" height="59">
			<path d="M36.6931 9.24292H223.873V67.0168H36.6931V9.24292Z" fill="white" />
		</mask>
		<g mask="url(#mask0)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M37.3018 46.5379H43.701V21.0786H37.3018V46.5379ZM40.5019 9.24292C42.6866 9.24292 44.3119 10.9262 44.3119 13.0181C44.3119 15.1619 42.6866 16.7945 40.5019 16.7945C38.3689 16.7945 36.6931 15.1619 36.6931 13.0181C36.6931 10.9262 38.3689 9.24292 40.5019 9.24292Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M51.2891 13.4774H57.6895V21.0796H64.2411V26.385H57.6895V37.9662C57.6895 40.62 58.7061 41.7932 61.1934 41.7932C62.2616 41.7932 63.1247 41.5894 63.9867 41.3349V46.4883C63.1751 46.7934 61.1429 47.1503 59.5176 47.1503C53.5253 47.1503 51.2891 43.5282 51.2891 37.66V26.385H46.5657V21.0796H51.2891V13.4774Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M71.6973 38.9366C72.0537 41.2842 73.577 42.6612 76.3703 42.6612C78.8094 42.6612 80.5356 41.4373 80.5356 39.396C80.5356 37.7634 79.6714 36.8953 77.7927 36.3864L74.0344 35.3652C69.6662 34.2427 67.2283 32.1 67.2283 28.0175C67.2283 23.3753 71.1895 20.467 76.2179 20.467C81.6531 20.467 84.6997 23.6309 85.2086 28.0692H79.7734C79.6714 26.4873 78.6054 24.9583 76.3703 24.9583C74.3897 24.9583 73.0693 26.028 73.0693 27.7123C73.0693 29.2942 73.9839 29.9056 75.8121 30.4157L80.3327 31.6913C84.3948 32.815 86.3766 35.1603 86.3766 38.8342C86.3766 43.8851 81.6027 47.1502 76.4208 47.1502C71.1391 47.1502 66.9234 44.7025 66.2632 38.9366H71.6973Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M92.3128 13.4774H98.7131V21.0796H105.265V26.385H98.7131V37.9662C98.7131 40.62 99.7298 41.7932 102.217 41.7932C103.284 41.7932 104.148 41.5894 105.01 41.3349V46.4883C104.199 46.7934 102.167 47.1503 100.541 47.1503C94.549 47.1503 92.3128 43.5282 92.3128 37.66V26.385H87.5894V21.0796H92.3128V13.4774Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M120.522 41.8441C124.738 41.8441 128.295 38.7321 128.295 33.8343C128.295 28.9355 124.738 25.7728 120.522 25.7728C115.951 25.7728 112.903 29.3949 112.903 33.8343C112.903 38.2727 115.951 41.8441 120.522 41.8441ZM134.694 21.0788V46.5381H128.547V42.1504C127.074 44.7524 123.723 47.1506 119.304 47.1506C111.786 47.1506 106.503 41.1303 106.503 33.8343C106.503 26.4877 111.786 20.4674 119.304 20.4674C123.723 20.4674 127.176 22.7632 128.446 25.4665V21.0788H134.694Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M142.378 13.4774H148.778V21.0796H155.329V26.385H148.778V37.9662C148.778 40.62 149.794 41.7932 152.282 41.7932C153.349 41.7932 154.213 41.5894 155.075 41.3349V46.4883C154.263 46.7934 152.231 47.1503 150.606 47.1503C144.614 47.1503 142.378 43.5282 142.378 37.66V26.385H137.654V21.0796H142.378V13.4774Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M158.445 21.079H164.835C164.838 21.079 164.84 21.0812 164.84 21.0812V46.5339C164.84 46.5339 164.838 46.5383 164.835 46.5383H158.445C158.443 46.5383 158.441 46.5361 158.441 46.5361V21.0834C158.441 21.0834 158.443 21.079 158.445 21.079ZM161.641 9.24329C163.825 9.24329 165.45 10.9265 165.45 13.0185C165.45 14.9761 164.093 16.5084 162.194 16.7585C160.031 17.0438 157.966 15.4365 157.838 13.2498C157.709 11.0521 159.429 9.24329 161.641 9.24329Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M174.593 33.8341C174.593 37.9662 177.336 41.7932 182.262 41.7932C187.189 41.7932 189.932 37.9662 189.932 33.8341C189.932 29.702 187.189 25.8243 182.262 25.8243C177.336 25.8243 174.593 29.702 174.593 33.8341ZM168.346 33.8341C168.346 26.8962 173.527 20.4672 182.262 20.4672C190.998 20.4672 196.179 26.8962 196.179 33.8341C196.179 40.7225 190.998 47.1504 182.262 47.1504C173.527 47.1504 168.346 40.7225 168.346 33.8341Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M206.141 46.5383H199.752C199.749 46.5383 199.747 46.5361 199.747 46.5361V21.0835C199.747 21.0835 199.749 21.079 199.752 21.079H205.939C205.942 21.079 205.944 21.0813 205.944 21.0813V25.3941C205.944 25.3996 205.951 25.4007 205.952 25.3952C207.127 22.4483 210.422 20.4666 214.375 20.4666C220.47 20.4666 223.873 24.9578 223.873 31.2833V46.5339C223.873 46.5339 223.871 46.5383 223.868 46.5383H217.478C217.476 46.5383 217.474 46.5361 217.474 46.5361V32.354C217.474 28.7319 215.848 26.0793 212.038 26.0793C208.533 26.0793 206.146 28.6295 206.146 32.3033V46.5339C206.146 46.5339 206.145 46.5383 206.141 46.5383Z"
				fill="#666666"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M188.633 56.9073V61.2268C188.972 60.5041 189.854 59.8916 191.034 59.8916C193.042 59.8916 194.452 61.4989 194.452 63.4608C194.452 65.4096 193.042 67.0168 191.034 67.0168C189.854 67.0168 188.959 66.3768 188.565 65.6817V66.8538H186.924V56.9073H188.633ZM190.695 61.3083C189.583 61.3083 188.633 62.1532 188.633 63.4608C188.633 64.7684 189.583 65.6002 190.695 65.6002C191.915 65.6002 192.742 64.6462 192.742 63.4608C192.742 62.2755 191.915 61.3083 190.695 61.3083Z"
				fill="#666666"
			/>
		</g>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M201.206 61.2678H203.163L200.129 68.545L198.89 71.6964H196.933L198.292 68.3389L195.349 61.2678H197.29L199.263 66.5119L201.206 61.2678Z"
			fill="#666666"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M214.884 73H214.609L216.476 67.8776H219.041C219.494 67.8776 219.979 67.5293 220.138 67.1072L222.164 61.5414C222.49 60.6332 221.974 59.8938 221.003 59.8938H217.447L214.462 68.0999L212.773 72.7575C208.754 71.7958 205.767 68.1843 205.767 63.875C205.767 59.6929 208.584 56.1647 212.425 55.0887L210.673 59.8938L207.772 67.8776H209.703L212.171 61.0873H213.627L211.158 67.8776H213.089L215.391 61.5414C215.716 60.6332 215.201 59.8938 214.23 59.8938H212.614L214.472 54.7596C214.609 54.7596 214.746 54.75 214.884 54.75C219.917 54.75 224 58.837 224 63.875C224 68.913 219.917 73 214.884 73ZM220.402 61.0873H218.945L216.919 66.6745H218.365L220.402 61.0873Z"
			fill="#666666"
		/>
	</svg>
</template>

<script>
	export default {
		name: 'FitstationSVG'
	};
</script>

<style scoped>
	svg {
		position: absolute;
		top: 30px;
		left: 30px;
		z-index: 99999;
	}
</style>
